import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import FileViews from '../../../constants/FileViews';

import ThemeIcons from '../../../theme/Icons';

import Icon from '../../misc/Icon';

const StyledViewSelector = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: -3px;
`;

const StyledViewTrigger = styled.button`
  display: flex;
  align-items: center;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.fontColorSecondary};
  border-radius: 4px;
  gap: 8px;
  
  &:hover {
    background-color: ${(props) => props.theme.secondaryColor};
    color: ${(props) => props.theme.primaryColor};
  }
`;

const StyledPopoverMenu = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 8px;
  background: ${(props) => props.theme.backgroundColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 1000;
`;

const StyledMenuItem = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.fontColorPrimary};
  gap: 8px;
  
  &:hover {
    background-color: ${(props) => props.theme.secondaryColor};
  }

  ${(props) => props.selected && `
    color: ${props.theme.primaryColor};
    background-color: ${props.theme.secondaryColor};
  `}
`;

const StyledMenuItemLabel = styled.span`
  font-size: 14px;
`;

const ViewSettings = ({ view, onViewChange, theme }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleViewSelect = (newView) => {
    onViewChange(newView);
    setIsOpen(false);
  };

  const currentView = view === FileViews.mobile ? 'mobile' : 'desktop';
  const currentIcon = view === FileViews.mobile ?
    ThemeIcons.settings.mobileScreen :
    ThemeIcons.settings.webScreen;

  return (
    <StyledViewSelector>
      <StyledViewTrigger
        onClick={() => setIsOpen(!isOpen)}
        theme={theme}
      >
        <Icon
          icon={currentIcon}
          size={currentIcon === ThemeIcons.settings.mobileScreen ? 'lg' : null}
          color={theme.fontColorPrimary}
        />
        <Icon
          icon={ThemeIcons.misc.chevronDown}
          size={14}
          color={theme.fontColorPrimary}
        />
      </StyledViewTrigger>

      {isOpen && (
        <StyledPopoverMenu theme={theme}>
          <StyledMenuItem
            theme={theme}
            selected={currentView === 'desktop'}
            onClick={() => handleViewSelect(FileViews.desktop)}
          >
            <Icon
              icon={ThemeIcons.settings.webScreen}
              color={theme.fontColorPrimary}
            />
            <StyledMenuItemLabel>Desktop</StyledMenuItemLabel>
          </StyledMenuItem>
          <StyledMenuItem
            theme={theme}
            selected={currentView === 'mobile'}
            onClick={() => handleViewSelect(FileViews.mobile)}
          >
            <Icon
              icon={ThemeIcons.settings.mobileScreen}
              size="lg"
              color={theme.fontColorPrimary}
            />
            <StyledMenuItemLabel style={{ paddingLeft: 4 }}>Mobile</StyledMenuItemLabel>
          </StyledMenuItem>
        </StyledPopoverMenu>
      )}
    </StyledViewSelector>
  );
};

ViewSettings.propTypes = {
  view: PropTypes.oneOf([FileViews.desktop, FileViews.mobile]),
  onViewChange: PropTypes.func,
  theme: PropTypes.object,
};

export default ViewSettings;